import React, { useEffect, useState } from "react"
import API from "../../api"
import Button from "../../components/button"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import { useQueryParams } from "../../hooks/useQueryParams"

import Header from "../../components/header"

import Checkbox from "../../components/checkbox"
import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import useInfiniteScroll from "../../hooks/useInfiniteScroll"
import { debounce } from "../../helpers/debounce"
import Image from "../image"
import { ROUTES } from "../../routes"
import { useLanguage } from "@languages/index"

const ModelIndex = (props: any) => {
  const params = useQueryParams()
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.models }

  const navigate = useNavigate()

  const tabs = [
    { name: languageTexts.index_tabs_1, value: null },
    { name: languageTexts.index_tabs_2, value: "supported" },
    { name: languageTexts.index_tabs_3, value: "rejected" },
  ]
  const [selectedModelTab, setModelTab] = useState(null)

  const [isShowSuggestedModels, setShowSuggestedModels] = useState(false)
  const [isShowGolfModels, setShowGolfModels] = useState(false)

  const [models, setModels] = useState([])
  const [modelCnt, setModelCnt] = useState(0)

  const [currentPage, setCurrentPage] = useState(1)
  const [isContentEnded, setIsContentEnded] = useState(false)
  const [isFetchFinished, setIsFetchFinished] = useState(false)
  const [isFetching, setIsFetching] = useInfiniteScroll(() => {
    if (models.length) {
      fetchModels()
    }
  })

  useEffect(() => {
    if (!models.length && !isContentEnded) {
      fetchModels(true)
    }
  }, [models])

  useEffect(() => {}, [models])

  useEffect(() => {
    fetchModels(true)
  }, [isShowSuggestedModels, isShowGolfModels])

  useEffect(() => {
    fetchModels(true)
  }, [selectedModelTab])

  const fetchModels = (refresh?: Boolean) => {
    if (refresh) {
      setIsContentEnded(false)
    }

    if (isContentEnded && !refresh) {
      return false
    }

    const targetPage = refresh ? 1 : currentPage

    let params = {
      brandToken: props.auth.token,
      page: targetPage,
    }

    if (isShowSuggestedModels) {
      params["isSuggested"] = isShowSuggestedModels
    }

    if (isShowGolfModels) {
      params["isGolf"] = isShowGolfModels
    }

    switch (selectedModelTab) {
      case "supported":
        params["isSupported"] = true
        break
      case "rejected":
        params["isRejected"] = true
        break
    }

    debounce(() => {
      API.Model.index({
        ...params,
      })
        .then((response) => {
          setModels(targetPage === 1 ? response.data.models : models.concat(response.data.models))

          setModelCnt(response.data.count)
          setCurrentPage(targetPage + 1)
          setIsContentEnded(response.data.paginator.currentPage == response.data.paginator.lastPage)
        })
        .catch((error) => {
          props.showModal({ text: error.message })
        })
        .finally(() => {
          setIsFetching(false)
          setIsFetchFinished(true)
        })
    }, 500)
  }

  const renderPostings = () => {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 auto-cols-max">
        {models.map((model, index) => {
          return (
            <div
              className="hover:opacity-90"
              key={`Model_${model.id}`}
              onClick={() => {
                props.setPost({
                  show: { id: model.id },
                })

                props.setModal({
                  isVisible: true,
                  content: () => {
                    return (
                      <div>
                        <h1>test</h1>
                      </div>
                    )
                  },
                })
              }}
            >
              <img className="thumbnail" src={model.thumbnailUrl} />
            </div>
          )
        })}
      </div>
    )
  }

  const renderBanner = () => {
    return (
      <div
        className="flex flex-col justify-center border-b border-slate-100 cursor-pointer"
        onClick={() => {
          navigate(ROUTES.MODEL_INTRO.PATH)
        }}
      >
        <img className="w-full" src="assets/images/banners/brand-model-banner.png" />
      </div>
    )
  }

  const renderModelTabs = () => {
    return (
      <div className="flex flex-row gap-3 py-5 my-5">
        {tabs.map((tab, index) => {
          return (
            <span
              key={`ModelTabKey${index}`}
              className={clsx({
                prose: true,
                "cursor-pointer": true,
                "prose-xl": true,
                "font-bold": true,
                "text-black": selectedModelTab === tab.value,
                "text-slate-400": selectedModelTab !== tab.value,
              })}
              onClick={() => {
                setModelTab(tab.value)
              }}
            >
              {tab.name}
            </span>
          )
        })}
      </div>
    )
  }

  const renderModelHeader = () => {
    return (
      <div className="flex flex-row justify-between">
        <div>
          <span className="prose prose-md text-black">{languageTexts._index_text_1(modelCnt.toLocaleString())}</span>
        </div>

        <div className="flex flex-row gap-3">
          <Checkbox
            className="cursor-pointer self-center"
            checked={isShowGolfModels}
            onClick={() => {
              setShowGolfModels(!isShowGolfModels)
            }}
            onTextPress={() => {
              setShowGolfModels(!isShowGolfModels)
            }}
            text={languageTexts.index_text_2}
            textStyle={{ textColor: "black" }}
          />
          <Checkbox
            className="cursor-pointer self-center"
            checked={isShowSuggestedModels}
            onClick={() => {
              setShowSuggestedModels(!isShowSuggestedModels)
            }}
            onTextPress={() => {
              setShowSuggestedModels(!isShowSuggestedModels)
            }}
            text={languageTexts.index_text_3}
            textStyle={{ textColor: "black" }}
          />
        </div>
      </div>
    )
  }

  const renderModels = () => {
    const placeHolderImgUrl = `/assets/icons/ic-profile-default.png`
    // const placeHolderImgUrl = `http://placekitten.com/g/56/56`;

    const displayPlaceholderImage = (error) => {
      error.target.src = placeHolderImgUrl
    }

    if (!models.length && isFetchFinished) {
      return (
        <>
          <div className="flex flex-col items-center py-3.5 min-w-md max-w-md w-full mx-auto">
            <div className="flex flex-col items-center text-center w-full">
              <div>
                <span className="prose prose-xl text-slate-400">
                  {selectedModelTab == "rejected" ? languageTexts.index_text_4 : null}

                  {selectedModelTab == "supported" ? languageTexts.index_text_5 : null}
                </span>
              </div>

              <div className="mt-10 min-w-md max-w-md w-full">
                <Button
                  className={"rounded-sm w-full py-2"}
                  text={languageTexts.index_text_6}
                  buttonColor={"#FFBC64"}
                  borderColor={"#FFBC64"}
                  textColor={"WHITE"}
                  onClick={() => {
                    setShowSuggestedModels(true)
                    setModelTab(tabs[0].value)
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )
    }

    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 grid-flow-row gap-x-24">
        {models.map((model) => {
          return (
            <div className="flex flex-col mb-16">
              <div className="flex flex-row items-center py-3.5">
                <div className="rounded-full overflow-hidden w-14 h-14">
                  <img className="w-full h-full object-cover" onError={displayPlaceholderImage} src={model.user.profileImageUrl} />
                </div>
                <div className="ml-3">
                  <span
                    className="cursor-pointer hover:underline"
                    onClick={() => {
                      window.open(`https://instagram.com/${model.instaUserId}${props?.brand?.isCategoryBeauty ? "reels/" : ""}`, "_blank")
                    }}
                  >
                    {model.user.username}
                  </span>
                </div>
                {model.suggestedAt ? (
                  <div className="flex ml-2 border rounded-sm border-black px-1 items-center">
                    <span className="prose text-xs text-black font-semibold text-center">{languageTexts.popularity}</span>
                  </div>
                ) : null}
                <div className="flex flex-row ml-auto">
                  {!model.support && !model.reject ? (
                    <>
                      <div className="ml-2">
                        <Button
                          className={"py-0 px-2 rounded-sm"}
                          text={languageTexts.index_text_7}
                          bordered
                          borderColor={"#FFBC64"}
                          buttonColor={"#FFBC64"}
                          textColor="white"
                          onClick={() => {
                            showModelSupportModal(model.userId, model.support)
                          }}
                        />
                      </div>
                      <div className="ml-2 rounded-sm border-secondary">
                        <Button
                          className={"py-0 px-2 rounded-sm"}
                          text={languageTexts.index_text_8}
                          bordered
                          borderColor={"#FD5B9C"}
                          buttonColor={"#FD5B9C"}
                          textColor="white"
                          onClick={() => {
                            showModelRejectModal(model.userId, model.reject)
                          }}
                        />
                      </div>
                    </>
                  ) : null}
                  {model.support ? (
                    <div className="ml-2">
                      <Button
                        className={"py-0 px-2 rounded-sm"}
                        text={languageTexts.index_text_9}
                        bordered
                        borderColor={"#FFBC64"}
                        buttonColor={"white"}
                        textColor="#FFBC64"
                        onClick={() => {
                          showModelSupportModal(model.userId, model.support)
                        }}
                      />
                    </div>
                  ) : null}
                  {model.reject ? (
                    <div className="ml-2">
                      <Button
                        className={"py-0 px-2 rounded-sm"}
                        text={languageTexts.index_text_10}
                        bordered
                        borderColor={"#FD5B9C"}
                        buttonColor={"white"}
                        textColor="#FD5B9C"
                        onClick={() => {
                          showModelRejectModal(model.userId, model.reject)
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex flex-row h-full">
                <div className="row columns-3 gap-0.5 h-full">
                  {model.bestShots.map((posting) => {
                    return (
                      <div
                        className="object-cover"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        onClick={() => {
                          props.setModal({
                            isVisible: true,
                            className: "w-2/5",
                            content: () => {
                              return (
                                <Image
                                  images={[
                                    {
                                      src: posting.imgUrl,
                                      id: 0,
                                    },
                                  ]}
                                />
                              )
                            },
                          })
                        }}
                      >
                        <img className="h-full object-cover" src={posting.thumbSmUrl} />
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  const showModelSupportModal = (userId: number, isDelete: boolean = false) => {
    debounce(() => {
      props.showModal({
        title: isDelete ? languageTexts.model_support_title_1 : languageTexts.model_support_title_2,
        text: isDelete ? languageTexts.model_support_text_1 : languageTexts.model_support_text_2,
        cancel: () => {},
        confirm: () => {
          toggleSupport(userId)
        },
      })
    }, 500)
  }

  const toggleSupport = (userId: number) => {
    debounce(() => {
      API.Model.toggleSupport({
        brandToken: props.auth.token,
        userId: userId,
      })
        .then((response) => {
          props.showModal({ text: response.message })

          const modelsCopy = models.map((model) => (model.id == response.data.model.id ? response.data.model : model))

          setModels([...modelsCopy])
        })
        .catch((error) => {
          props.showModal({ text: error.message })
        })
    }, 400)
  }

  const showModelRejectModal = (userId: number, isDelete: boolean = false) => {
    debounce(() => {
      props.showModal({
        title: isDelete ? languageTexts.model_reject_title_1 : languageTexts.model_reject_title_2,
        text: isDelete ? languageTexts.model_reject_text_1 : languageTexts.model_reject_text_2,
        cancel: () => {},
        confirm: () => {
          toggleReject(userId)
        },
      })
    }, 400)
  }

  const toggleReject = (userId: number) => {
    debounce(() => {
      API.Model.toggleReject({
        brandToken: props.auth.token,
        userId: userId,
      })
        .then((response) => {
          props.showModal({
            text: response.message,
          })

          const modelsCopy = models.map((model) => (model.id == response.data.model.id ? response.data.model : model))

          setModels([...modelsCopy])
        })
        .catch((error) => {
          props.showModal({
            text: error.message,
          })
        })
    }, 400)
  }

  const renderLoadingIndicator = () => {
    return isFetching && !isContentEnded ? (
      <div className="flex flex-row justify-center text-center my-5">
        <span className="prose prose-xl text-slate-400">{languageTexts.loading_1}</span>
      </div>
    ) : null
  }

  return (
    <>
      <div className="header-container">{renderBanner()}</div>

      <div className="px-5 xl:px-10 pb-10">
        {renderModelTabs()}
        {renderModelHeader()}
        {renderModels()}
        {renderLoadingIndicator()}
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(ModelIndex)
